/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import '@quasar/extras/roboto-font/roboto-font.css'




// We load Quasar stylesheet file
import 'quasar/dist/quasar.styl'




import 'src/css/app.styl'

import '@quasar/quasar-ui-qcalendar/src/index.sass'


import Vue from 'vue'
import createApp from './app.js'




import qboot_Bootappredirect from 'boot/app-redirect'

import qboot_Bootaxios from 'boot/axios'

import qboot_Bootdateutil from 'boot/date-util'

import qboot_Bootdownloadfile from 'boot/download-file'

import qboot_Bootextensionicon from 'boot/extension-icon'

import qboot_Boothasranking from 'boot/has-ranking'

import qboot_Bootintelwalocal from 'boot/intel-wa-local'

import qboot_Bootfontawesomepro from 'boot/fontawesome-pro'

import qboot_Booti18next from 'boot/i18next'

import qboot_Bootmimetypes from 'boot/mime-types'

import qboot_Bootlottieanimation from 'boot/lottie-animation'

import qboot_Bootpushnotifications from 'boot/push-notifications'

import qboot_Bootqrcodereader from 'boot/qrcode-reader'

import qboot_Bootqs from 'boot/qs'

import qboot_Bootsentry from 'boot/sentry'

import qboot_Bootslugify from 'boot/slugify'

import qboot_Boottruncatelinks from 'boot/truncate-links'

import qboot_Bootvueanalytics from 'boot/vue-analytics'

import qboot_Bootvuecountdown from 'boot/vue-countdown'

import qboot_Bootvuelongclick from 'boot/vue-long-click'

import qboot_Bootvueplyr from 'boot/vue-plyr'

import qboot_Bootvuescrollto from 'boot/vue-scrollto'

import qboot_Bootvuesocialsharing from 'boot/vue-social-sharing'

import qboot_Bootvuezoomer from 'boot/vue-zoomer'

import qboot_Bootvue2gtm from 'boot/vue2-gtm'

import qboot_Bootvuefire from 'boot/vuefire'

import qboot_Bootvuelidate from 'boot/vuelidate'

import qboot_Bootvuerecaptcha from 'boot/vue-recaptcha'

import qboot_Bootmask from 'boot/mask'

import qboot_Bootvueics from 'boot/vue-ics'

import qboot_Quasarquasarappextensionqcalendarsrcbootregisterjs from '@quasar/quasar-app-extension-qcalendar/src/boot/register.js'












const publicPath = ``


async function start () {
  const { app, store, router } = await createApp()

  

  
  let hasRedirected = false
  const redirect = url => {
    hasRedirected = true
    const normalized = Object(url) === url
      ? router.resolve(url).route.fullPath
      : url

    window.location.href = normalized
  }

  const urlPath = window.location.href.replace(window.location.origin, '')
  const bootFiles = [qboot_Bootappredirect,qboot_Bootaxios,qboot_Bootdateutil,qboot_Bootdownloadfile,qboot_Bootextensionicon,qboot_Boothasranking,qboot_Bootintelwalocal,qboot_Bootfontawesomepro,qboot_Booti18next,qboot_Bootmimetypes,qboot_Bootlottieanimation,qboot_Bootpushnotifications,qboot_Bootqrcodereader,qboot_Bootqs,qboot_Bootsentry,qboot_Bootslugify,qboot_Boottruncatelinks,qboot_Bootvueanalytics,qboot_Bootvuecountdown,qboot_Bootvuelongclick,qboot_Bootvueplyr,qboot_Bootvuescrollto,qboot_Bootvuesocialsharing,qboot_Bootvuezoomer,qboot_Bootvue2gtm,qboot_Bootvuefire,qboot_Bootvuelidate,qboot_Bootvuerecaptcha,qboot_Bootmask,qboot_Bootvueics,qboot_Quasarquasarappextensionqcalendarsrcbootregisterjs]

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    if (typeof bootFiles[i] !== 'function') {
      continue
    }

    try {
      await bootFiles[i]({
        app,
        router,
        store,
        Vue,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        window.location.href = err.url
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  

    

    

    
      new Vue(app)
    

    

    

  

}

start()
